import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Loader2, Users, CheckCircle2, ShieldCheck, BarChart3 } from "lucide-react";

const BENEFITS = [
  { icon: Users, title: "Gère tes artistes", desc: "Centralise tous tes artistes dans un espace pro dédié." },
  { icon: BarChart3, title: "Suis leur progression", desc: "XP, projets, statistiques et activité en un coup d'œil." },
  { icon: CheckCircle2, title: "Accompagne au quotidien", desc: "Missions, validations et objectifs (selon autorisations)." },
  { icon: ShieldCheck, title: "Données protégées", desc: "Tu n'accèdes qu'aux artistes qui t'ont autorisé." },
];

export default function BecomeManager() {
  const { identity, becomeManager } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const alreadyManager = identity?.roles?.includes("MANAGER");

  const activate = async () => {
    setBusy(true);
    try {
      await becomeManager();
      toast.success("Espace Manager activé ! 🎉");
      navigate("/manager");
    } catch {
      toast.error("Activation impossible, réessaie.");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6" data-testid="become-manager">
      <div className="text-center">
        <div className="w-14 h-14 rounded-2xl gold-gradient flex items-center justify-center mx-auto mb-4 glow-gold"><Users className="w-7 h-7 text-black" /></div>
        <h1 className="font-display text-3xl font-extrabold">Développez et accompagnez vos artistes</h1>
        <p className="text-zinc-400 text-sm mt-2">Passez en mode Manager et pilotez la carrière de vos artistes depuis un espace professionnel.</p>
      </div>

      <div className="grid sm:grid-cols-2 gap-3">
        {BENEFITS.map((b) => (
          <div key={b.title} className="bg-[#18181E] border border-zinc-800 rounded-2xl p-4">
            <b.icon className="w-5 h-5 text-amber-400 mb-2" />
            <p className="font-semibold text-zinc-100 text-sm">{b.title}</p>
            <p className="text-xs text-zinc-500 mt-1">{b.desc}</p>
          </div>
        ))}
      </div>

      <div className="bg-[#18181E] border border-amber-500/30 rounded-3xl p-6 text-center">
        <p className="text-xs font-mono uppercase tracking-wider text-amber-400">Offre Manager</p>
        <p className="font-display text-3xl font-extrabold mt-1">Gratuit <span className="text-base text-zinc-500 font-normal">pour le moment</span></p>
        <span className="inline-block mt-2 text-[11px] px-3 py-1 rounded-full bg-zinc-900 border border-zinc-700 text-zinc-400" data-testid="payment-todo-badge">💳 Paiement à configurer</span>
        {alreadyManager ? (
          <button onClick={() => navigate("/manager")} data-testid="go-manager-btn" className="mt-5 w-full h-12 rounded-xl gold-gradient text-black font-semibold">Accéder à mon espace Manager</button>
        ) : (
          <button onClick={activate} disabled={busy} data-testid="activate-manager-btn" className="mt-5 w-full h-12 rounded-xl gold-gradient text-black font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-60">
            {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : null} Devenir Manager
          </button>
        )}
        <p className="text-[11px] text-zinc-600 mt-3">Aucun paiement requis. Ton espace Artiste reste inchangé — tu pourras basculer entre les deux à tout moment.</p>
      </div>
    </div>
  );
}
